import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultTextAreaField } from 'src/components/mui-overrides/Textarea';

export const InvestmentDetailsAdditionTextField: FC = () => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  return (
    <DefaultTextAreaField
      label={t('dashboard.assets.addedit.investment.investmentinformation.fields.investmentDetailsAddition.label')}
      fieldName="descriptions.investmentDetailsAddition"
      formik={formik}
    />
  );
};
